// Turkish date/time/duration formatting.

const DAY_NAMES = ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
const DAY_SHORT = ['Paz','Pzt','Sal','Çar','Per','Cum','Cmt'];
const MONTH_NAMES = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];

export function parseDate(iso) {
  // Accepts 'YYYY-MM-DD' or 'YYYY-MM-DD HH:MM:SS' or ISO
  if (!iso) return null;
  const [d, t] = String(iso).split(/[ T]/);
  const [y, m, day] = d.split('-').map(Number);
  const [hh = 0, mm = 0, ss = 0] = (t || '0:0:0').split(':').map(Number);
  return new Date(y, (m || 1) - 1, day || 1, hh, mm, ss);
}

export function todayIso() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}

export function isoDate(d) {
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}

export function fmtDate(iso, opts = {}) {
  const d = parseDate(iso);
  if (!d) return '';
  const day = d.getDate();
  const mon = MONTH_NAMES[d.getMonth()];
  const yr = d.getFullYear();
  if (opts.short) return `${day} ${mon.slice(0,3)}`;
  return `${day} ${mon} ${yr}`;
}

export function fmtDateRange(startIso, endIso) {
  const s = parseDate(startIso), e = parseDate(endIso);
  if (!s || !e) return '';
  const sameYear = s.getFullYear() === e.getFullYear();
  const sameMonth = sameYear && s.getMonth() === e.getMonth();
  if (sameMonth) return `${s.getDate()}–${e.getDate()} ${MONTH_NAMES[s.getMonth()]} ${s.getFullYear()}`;
  if (sameYear) return `${s.getDate()} ${MONTH_NAMES[s.getMonth()].slice(0,3)} – ${e.getDate()} ${MONTH_NAMES[e.getMonth()].slice(0,3)} ${s.getFullYear()}`;
  return `${fmtDate(startIso)} – ${fmtDate(endIso)}`;
}

export function dayName(iso, short = false) {
  const d = parseDate(iso);
  if (!d) return '';
  return (short ? DAY_SHORT : DAY_NAMES)[d.getDay()];
}

export function fmtTime(t) {
  if (!t) return '';
  return t.slice(0, 5); // HH:MM
}

export function fmtDuration(minutes) {
  const n = Number(minutes);
  if (!n || Number.isNaN(n)) return '0 dk';
  const h = Math.floor(n / 60), m = n % 60;
  if (h === 0) return `${m} dk`;
  if (m === 0) return `${h} sa`;
  return `${h} sa ${m} dk`;
}

export function daysInWeek(startIso) {
  const s = parseDate(startIso);
  const out = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(s.getFullYear(), s.getMonth(), s.getDate() + i);
    out.push(isoDate(d));
  }
  return out;
}

export function statusLabel(s) {
  return ({
    pending: 'Bekliyor',
    in_progress: 'Devam ediyor',
    completed: 'Tamamlandı',
    postponed: 'Ertelendi',
    failed: 'Yapılmadı',
  })[s] || s;
}

export function statusIcon(s) {
  return ({
    pending:     '○',
    in_progress: '▸',
    completed:   '✓',
    postponed:   '⤴',
    failed:      '✕',
  })[s] || '';
}

export function priorityLabel(p) {
  return ({ low: 'Düşük', normal: 'Normal', high: 'Yüksek', critical: 'Kritik' })[p] || p;
}

export function visibilityLabel(v) {
  return v === 'visible_to_student' ? 'Öğrenciye görünür' : 'Yalnızca koç';
}

// YKS neti: doğru - 0.25 * yanlış (2 ondalık)
export function fmtNet(correct, incorrect) {
  const c = Number(correct) || 0;
  const i = Number(incorrect) || 0;
  return (c - 0.25 * i).toFixed(2);
}

export function taskTypeLabel(t) {
  return ({ study: 'Konu Çalışması', video: 'Video', practice: 'Soru Çözümü' })[t] || 'Konu Çalışması';
}
export function taskTypeIcon(t) {
  return ({ study: '📖', video: '▶', practice: '✍' })[t] || '📖';
}

export function sourceTypeLabel(t) {
  return ({ video: 'Video', question_bank: 'Soru Bankası', book: 'Kitap', other: 'Diğer' })[t] || 'Diğer';
}
export function sourceTypeIcon(t) {
  return ({ video: '▶', question_bank: '✍', book: '📚', other: '•' })[t] || '•';
}
